export default "{\n    \"emptyText\": \"Cliquez pour sélectionner un fournisseur\",\n    \"placeholderText\": \"Rechercher par nom\"\n}\n"